import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { safeLocalStorage } from "./safeLocalStorage";

const toNum = (v: unknown, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

export function useQueryTab(param = "tab", def = 0) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabValue, setTabValue] = useState(() => toNum(searchParams.get(param), def));

  useEffect(() => setTabValue(toNum(searchParams.get(param), def)), [searchParams, param, def]);

  const change = (v: number) => {
    setTabValue(v);
    const p = new URLSearchParams(searchParams);
    v === def ? p.delete(param) : p.set(param, String(v));
    setSearchParams(p, { replace: true });
  };

  return { tabValue, setTabValue: change };
}

export function useStorageTab(def = 0, key?: string) {
  const { pathname } = useLocation();
  const storageKey = key ?? `tab:${pathname}`;
  const [tab, setTab] = useState(() => toNum(safeLocalStorage.get(storageKey), def));

  useEffect(() => setTab(toNum(safeLocalStorage.get(storageKey), def)), [storageKey, def]);

  const change = (v: number) => {
    setTab(v);
    safeLocalStorage.set(storageKey, String(v));
  };

  return { tab, setTab: change };
}
